import DomesticFooter from './domestic';
import OverseasFooter from './overseas';

// eslint-disable-next-line no-undef
const Footer = IS_OVERSEAS ? OverseasFooter : DomesticFooter;
export default Footer;
